import React, { createContext, useState, useEffect } from "react";
import { FeedEntryType } from "protogen/advisors_service_pb";
import { useLocation, useSearchParams } from "react-router-dom";

type ActivityFeedFilter = {
  entryType: FeedEntryType;
  updateEntryType: (entryType: FeedEntryType) => void;
};

export const ActivityFeedFilterContext = createContext<ActivityFeedFilter>({
  entryType: FeedEntryType.UNSPECIFIED,
  updateEntryType: () => {},
});

export default ({ children }: { children: React.ReactNode }) => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const [entryType, setEntryType] = useState<FeedEntryType>(
    FeedEntryType.UNSPECIFIED,
  );

  useEffect(() => {
    const adminView = searchParams.get("adminView");

    if (adminView) {
      setEntryType(FeedEntryType.ADMIN_ALL);
    } else {
      setEntryType(FeedEntryType.UNSPECIFIED);
    }
  }, [location.pathname, searchParams]);

  return (
    <ActivityFeedFilterContext.Provider
      value={{
        entryType,
        updateEntryType: setEntryType,
      }}
    >
      {children}
    </ActivityFeedFilterContext.Provider>
  );
};
